<template>
  <div>
    <div v-if="itemView.elements">
      <div class="panel-title" :class="itemView.PanelClass || 'panel-title'">
        <a
          :data-parent="'#' + accordionParentName"
          data-toggle="collapse"
          :href="'#accordionItem' + accordionParentName + '-' + itemView.title"
          aria-expanded="false"
        >
          <span class="open-sub"></span>
          {{ itemView.title }}
        </a>
      </div>

      <div
        :id="'accordionItem' + accordionParentName + '-' +  itemView.title"
        class="panel-collapse collapse"
        role="tablist"
        aria-expanded="false"
      >
        <div class="panel-content">
          <div
            :id="itemView.level + itemView.title"
            v-if="itemView.elements"
            class="panel-group accordion"
          >
            <div
              class="panel"
              v-for="item in itemView.elements"
              :key="item.title"
            >
              <video-group-item
                :name="item.level + item.title"
                v-bind:itemView="item"
                v-bind:accordionParentName="itemView.level + itemView.title"
              />
            </div>
          </div>
        </div>
      </div>
    </div>

    <div v-else>
      <button
        type="button"
        class="list-group-item dark-group"
        v-bind:class="{ active: video == videoToView }"
        v-for="video in itemView"
        v-on:click="OpenVideo(video)"
        :key="video.id"
      >
        {{ video.Title }}
      </button>
    </div>

    <video-modal
      v-bind:videoView="videoToView"
      v-on:closeModal="videoToView = null"
    />
  </div>
</template>
  
  <style scoped>
.sub-panel-title a {
  color: #ee163b;
}

.thirth-panel-title a {
  color: #b3b3b3;
}
</style>
  
  <script>
import VideoModal from "../../components/VideoModal.vue";
import VideoGroupItem from "../auth/VideoGroupItem.vue";

export default {
  name: "video-group-item",
  props: ["itemView", "accordionParentName"],
  components: {
    VideoModal,
    VideoGroupItem,
  },
  data() {
    return {
      videoToView: null,
      baseUrl: process.env.VUE_APP_API_URL,
    };
  },
  methods: {
    OpenVideo(video) {
      this.videoToView = video;
    },
  },
};
</script>
  